import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useShop } from "../context/ShopContext";
import { useLocale } from "../context/LocaleContext";
import { pixelConfigured, getConsent, setConsent, trackWithConsent } from "../lib/metaPixel";

// Guscio "nudo" per le landing: logo piccolo, contenuto, footer minimo.
// Niente menu, carrello o switch lingua: l'unica azione e' il form.
const LandingShell = ({ children, pixelEvents = [] }) => {
  const { lang } = useShop();
  const { lp } = useLocale();
  const [consent, setConsentState] = useState(() => (typeof window === "undefined" ? null : getConsent()));
  const showConsent = pixelConfigured() && consent === null;

  const choose = (value) => {
    setConsent(value);
    setConsentState(value);
    if (value === "yes") trackWithConsent(pixelEvents);
  };

  const t = lang === "it"
    ? { cookie: "Uso il pixel Meta solo per misurare se questa pagina funziona. Nessuna profilazione da parte mia.", yes: "Accetta", no: "Rifiuta", privacy: "Privacy policy", cookies: "Cookie policy", rights: "Tutti i diritti riservati" }
    : { cookie: "I use the Meta pixel only to measure whether this page works. No profiling on my side.", yes: "Accept", no: "Decline", privacy: "Privacy policy", cookies: "Cookie policy", rights: "All rights reserved" };

  return (
    <div className="idm-lp" data-testid="landing-shell">
      <header className="idm-lp-header">
        <div className="idm-lp-wrap">
          <Link to={lp("/")} className="idm-lp-logo" aria-label="IdeaMedia">
            <img src="/images/logo-full.png" alt="IdeaMedia" width="40" height="40" />
          </Link>
        </div>
      </header>

      {showConsent && (
        <div className="idm-lp-cookie" role="region" aria-label="Cookie">
          <div className="idm-lp-wrap idm-lp-cookie-inner">
            <p>{t.cookie}</p>
            <div>
              <button type="button" className="idm-lp-cookie-yes" onClick={() => choose("yes")}>{t.yes}</button>
              <button type="button" className="idm-lp-cookie-no" onClick={() => choose("no")}>{t.no}</button>
            </div>
          </div>
        </div>
      )}

      {children}

      <footer className="idm-lp-footer">
        <div className="idm-lp-wrap">
          <p>© {new Date().getFullYear()} IdeaMedia · {t.rights} · Via Fornaci 215/B, 35131 Padova · P.IVA IT05117210285</p>
          <p>
            <Link to={lp("/pagine/privacy-policy")}>{t.privacy}</Link>
            <span aria-hidden="true"> · </span>
            <Link to={lp("/pagine/cookie-policy")}>{t.cookies}</Link>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingShell;
